@import (reference) '../../../../../constants/spacing.module.less';

.drop-zone {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: @space-8;
  padding: @space-20 @space-16;
  border: 1.5px dashed var(--grey-400);
  border-radius: 8px;
  background-color: var(--grey-200);
  color: var(--grey-600);
  text-align: center;
  cursor: default;
  transition:
    border-color 0.2s ease,
    background-color 0.2s ease;

  &--drag-over {
    border-color: var(--blue-600);
    background-color: var(--grey-100);
  }

  &--disabled {
    opacity: 0.45;
    cursor: not-allowed;
    pointer-events: none;
  }
}

.drop-zone-icon {
  font-size: 24px;
  color: var(--grey-500);
  margin-bottom: @space-4;
}

.drop-zone-browse-row {
  align-items: center;
  justify-content: center;
}

.drop-zone-formats {
  color: var(--grey-500);
}

.drop-zone-progress {
  align-items: center;
  width: 100%;
  padding: 0 @space-16;
}

.drop-zone-progress-bar-row {
  align-items: center;
  flex-wrap: nowrap;
  width: 100%;
}

.drop-zone-progress-percentage {
  color: var(--grey-600);
  font-weight: 500;
  flex-shrink: 0;
}

.drop-zone-progress-bar {
  height: 8px;
  border-radius: 4px;
  overflow: hidden;
}

.hidden-file-input {
  display: none;
}
